import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PreFooterCTA from "./PreFooterCTA";

export const Layout = () => {
    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <PreFooterCTA />
            <Footer />
        </div>
    );
};

export default Layout;
